import { observer } from "mobx-react";
import React, { useState, useEffect } from "react";
import {
  Text,
  rem,
  Title,
  ActionIcon,
  Box,
  Group,
  Paper,
  Button,
  Image,
  Flex,
} from "@mantine/core";
import { useViewportSize } from "@mantine/hooks";
import { Cubby } from "../../stores/Cubby";
import { IconPlayerPlayFilled } from "@tabler/icons-react";
import RunningStatus from "../dataDisplay/runningStatus";

const StartAndStatus = observer(({ cubby }: { cubby: Cubby }) => {
  const [loading, setLoading] = useState(false);
  const { width } = useViewportSize();

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (loading) {
      timer = setTimeout(() => {
        setLoading(false);
      }, 15000);
    }
    return () => clearTimeout(timer);
  }, [loading]);

  const handleStartNode = () => {
    setLoading(true);
    cubby.cubbyLife("start_now");
  };

  const isMobile = width < 768; // You can adjust this breakpoint as needed
  //console.log("isMobile", isMobile);
  return (
    <>
      <Group
        justify="space-between"
        c="dimmed"
        mt=".3rem"
        mb="-.3045rem"
        wrap="nowrap"
        gap="xs"
        style={{ overflow: "hidden" }}
      >
        <Box style={{ flexShrink: 1, minWidth: 0 }}>
          {isMobile && !cubby.shouldShowStartNodeButton && (
            <Image
              h="40px"
              fit="contain"
              mb="-.5rem"
              src="https://daxwktpz4hkwd.cloudfront.net/logos/rizful-logo-mobile.png"
              alt="Rizful logo"
            />
          )}
          {!isMobile && (
            <Image
              fit="contain"
              h="40px"
              mb="-0.5rem"
              src="https://daxwktpz4hkwd.cloudfront.net/logos/rizful-logo-desktop.png"
              alt="Rizful logo"
            />
          )}
        </Box>
        <Group wrap="nowrap" gap="xs" style={{ flexShrink: 0 }}>
          {cubby.shouldShowStartNodeButton ? (
            <Button
              size={"xs"}
              loading={loading}
              rightSection={<IconPlayerPlayFilled />}
              onClick={handleStartNode}
              disabled={loading}
            >
              Start Node
            </Button>
          ) : null}
          <RunningStatus cubby={cubby} />
        </Group>
      </Group>
    </>
  );
});

export default StartAndStatus;
